import { useEffect } from "react"
import { getHasReleaseChanged } from "@/lib/get-has-release-changed"
import { SofiaEnvironment } from "@/sofia-environment"
import { useVersionStore } from "@/stores/useVersionStore"

export const useReleaseChangePolling = () => {
  const isStaleVersion = useVersionStore((state) => state.isStaleVersion)
  const markStale = useVersionStore((state) => state.markStale)

  useEffect(() => {
    if (SofiaEnvironment.Bff.IsDevelopment) {
      // locally we don't serve the release-info.json
      return
    }

    if (isStaleVersion) {
      return
    }

    let isCurrent = true

    const pollForUpdate = async () => {
      while (isCurrent) {
        try {
          const hasReleaseChanged = await getHasReleaseChanged()
          if (hasReleaseChanged) {
            markStale()
            break
          }
        } catch (error) {
          console.error(error)
        }
        await new Promise((resolve) => setTimeout(resolve, SofiaEnvironment.ReleaseCheckInterval))
      }
    }

    pollForUpdate()

    return () => {
      isCurrent = false
    }
  }, [isStaleVersion, markStale])
}
